import { VisitorInfoPage, Amenity } from 'generated/mos/org/getty/visitorinfo'
import { TranslatableStringValue } from 'generated/mos/translatable'

import { Schema } from 'helpers/schema'

import {
  createTranslatableStringValue,
  getTranslatableValue,
  setTranslatableValue,
} from 'helpers/translatables'

const isNonEmpty = (value: any) => {
  if (typeof value === 'string' && (!value || !value.trim().length)) {
    return false
  }

  return value
}

export const visitorInfoSchema: Schema<VisitorInfoPage.Entity> = {
  listTitle: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  listIconRef: {
    read: value => value ? value as any : undefined,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
}


export const amenitySchema: Schema<Amenity.Entity> = {
  name: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  headerImageRef: {
    read: value => value ? value as any : undefined,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
  headerImageAltText: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  descriptionText: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  extendedDescriptionText: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  openingHoursText: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  locationText: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  siteMapRef: {
    read: value => value ? value as any : undefined,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
  iconImageRef: {
    read: value => value ? value as any : undefined,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
  iconSelectedImageRef: {
    read: value => value ? value as any : undefined,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
}

export const contentPageSchema: Schema<VisitorInfoPage.AmenityCategory.Entity & VisitorInfoPage.Entity | VisitorInfoPage.AmenityCategory.Entity> = {
  ...visitorInfoSchema,
  headerTitle: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  headerImageRef: {
    read: value => value ? value as any : undefined,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
  headerImageAltText: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  descriptionText: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
}

export const htmlPageSchema: Schema<VisitorInfoPage.StaticWebPage.Entity & VisitorInfoPage.Entity | VisitorInfoPage.StaticWebPage.Entity> = {
  ...visitorInfoSchema,
  pageHtmlSource: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  navigationMode: {
    read: value => value ? value as any : undefined,
    write: value => isNonEmpty(value) ? value as any : undefined,
  }
}

export const urlPageSchema: Schema<VisitorInfoPage.URLWebPage.Entity & VisitorInfoPage.Entity | VisitorInfoPage.URLWebPage.Entity> = {
  ...visitorInfoSchema,
  pageUrl: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  navigationMode: {
    read: value => value ? value as any : undefined,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
}

export const imagePageSchema: Schema<VisitorInfoPage.SiteMap.Entity & VisitorInfoPage.Entity | VisitorInfoPage.SiteMap.Entity> = {
  ...visitorInfoSchema,
  headerTitle: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  mapPdfRef: {
    read: value => value ? value as any : undefined,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
  altText: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  defaultMapZoomFrame: {
    read: value => value ? value as any : undefined,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
}

export const appPageSchema: Schema<VisitorInfoPage.AppPage.Entity & VisitorInfoPage.Entity | VisitorInfoPage.AppPage.Entity> = {
  ...visitorInfoSchema,
  pageType: {
    read: value => value ? value as any : undefined,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
}

export const deepDivePageSchema: Schema<VisitorInfoPage.DeepDivePage.Entity & VisitorInfoPage.Entity | VisitorInfoPage.DeepDivePage.Entity> = {
  ...visitorInfoSchema,
  headerTitle: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  headerImageRef: {
    read: value => value ? value as any : undefined,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
  headerImageAltText: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  descriptionText: {
    read: (value, language) => value ? getTranslatableValue(value, language) as any : undefined,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
}
